export default "__VITE_ASSET__C0AAF0v1__"